import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getRetrieveSearchState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.retrieveSearch
);

export const shouldTriggerRetrieveSearchApi = createSelector(
  getRetrieveSearchState,
  ({ isReady, triggerRetrieveSearchLanding }) =>
    triggerRetrieveSearchLanding && !isReady
);

export const isRetrieveSearchStateReady = createSelector(
  getRetrieveSearchState,
  ({ isReady, triggerRetrieveSearchLanding, isError }) =>
    !triggerRetrieveSearchLanding || isReady || isError
);

export const getRetrieveSearchMcCacheKey = createSelector(
  getRetrieveSearchState,
  ({ retrieveSearchMcCacheKey }) => retrieveSearchMcCacheKey
);

export const getRetrieveSearchDataList = createSelector(
  getRetrieveSearchState,
  ({ retrieveSearchDataList }) => retrieveSearchDataList
);

export const getRetrieveSearchData = createSelector(
  getRetrieveSearchDataList,
  (retrieveSearchDataList) => {
    if (retrieveSearchDataList && retrieveSearchDataList[0]) {
      return retrieveSearchDataList[0];
    }

    return null;
  }
);
